export enum FeatureToggle {
  PhotoSearch = 'all.photo_search',
  WopiTestMode = 'wopi_test_mode',
  TimelineV2 = 'web.timeline_v2',
  People = 'peopleapi',
  FacesV2 = 'photos.facesv2',
  PhotoEditor = 'web.photo_editor',
  PhotoEditorInFiles = 'web.photo_editor_in_files',
  Referrals = 'b2_referrals',
  InAppBrowserBreakout = 'web.inapp_browser_breakout',
  InAppBrowserBreakoutIOS = 'web.inapp_browser_breakout_ios',
  InAppBrowserBreakoutAndroid = 'web.inapp_browser_breakout_android',
}
